module.exports = __webpack_public_path__ + "static/img/loading.02f9fbc.gif";